import localhost from "../../../apis/localhost";
import { setAllowedSitesAuthenticated } from "../allowedSitesSlice";
import { REQUEST_CONFIG } from "./allowedSitesConstants";
import {
  allowedSitesUrl,
  redirectUnlessSharepointError,
} from "./allowedSitesUtils";

export const checkAllowedSitesAuthentication =
  ({ isCloudMode }) =>
  async (dispatch) => {
    try {
      const { data } = await localhost.get(
        allowedSitesUrl(isCloudMode, "/authentication"),
        REQUEST_CONFIG
      );
      dispatch(setAllowedSitesAuthenticated(Boolean(data?.isAuthenticated)));
      return Boolean(data?.isAuthenticated);
    } catch (error) {
      redirectUnlessSharepointError(error);
      dispatch(setAllowedSitesAuthenticated(false));
      return false;
    }
  };
